module.exports = __webpack_public_path__ + "static/media/people4.448d0294.jpeg";